
const STORAGE_FOLLOWED_CONTENT = "followed-content"
const STORAGE_LAST_ACTIVE = "last-active"

const initialState = () => {
  return {
    activeTab: 0,
    error: null,
    user: {
      custom: {},
    },
    followedContent: [],
    isLoading: true,
    isInvalidJSON: false,
    lastActive: null,
  }
}

export default {
  middleware: 'auth',
  props: {
    isOpen: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return initialState()
  },
  async fetch() {
    this.user = this.$auth.user
    this.isLoading = false
  },
  computed: {
    isLoggedIn () {
      return this.$auth.loggedIn
    },
    userPreprCustomerId() {
      return this.user?.['https://mijn.eo.nl/preprCustomerId']
    },
    programs () {
      return this.followedContent.filter(content => content.type === "program") || []
    },
    persons () {
      return this.followedContent.filter(content => content.type === "person") || []
    },
    showMessageNoContent () {
      return this.programs && this.programs.length === 0 && this.persons && this.persons.length === 0
    },
    activeTabDefault () {
      return 0
    },
    publicationDates () {
      return this.followedContent.reduce((acc, content) => {
        const articles = content.articles && content.articles.length ? content.articles : []
        const articleDates = articles.map((article) => {
          return article.publishOn ? article.publishOn : ""
        })

        return [
          ...articleDates,
          ...acc,
        ]
      }, [])
    },
    newestPublicationDate () {
      return this.publicationDates.reduce((a, b) => {
        return new Date(a) > new Date(b) ? a : b;
      }, "");
    },
    showNotificationAlert () {
      const pubDate = new Date(this.newestPublicationDate)
      const activeDate = new Date(this.lastActive)

      return this.lastActive && (pubDate > activeDate) ? true : false
    },
  },
  watch: {
    followedContent (newState, oldState) {
      if (oldState !== newState) {
        this.fetchContent()
      }
    },
    showNotificationAlert (newState, oldState) {
      if (oldState !== newState) {
        this.$emit("notify", newState)
      }
    },
    isOpen (newState) {
      if (newState) {
        if (this.isOpen && this.showNotificationAlert) {
          this.setLastActive()
        }
      }
    },
  },
  mounted () {
    this.getStoredFollowedContent()
    this.getLastActive()

    window.addEventListener('follow-changed', () => {
      this.getStoredFollowedContent()
    })
  },
  methods: {
    getLastActive() {
      const storedLastActive = localStorage.getItem(STORAGE_LAST_ACTIVE)
      if (storedLastActive) {
        this.lastActive = storedLastActive
      }
    },
    setLastActive() {
      const now = new Date()
      if (now) {
        localStorage.setItem(STORAGE_LAST_ACTIVE, now.toISOString())
        this.lastActive = now.toISOString()
      }
    },
    getStoredFollowedContent () {
      try {
        const storedFollowString = localStorage.getItem(STORAGE_FOLLOWED_CONTENT)
        const isValidStoredFollow = this.isValidJSON(storedFollowString)
        this.isInvalidJSON = !isValidStoredFollow
        this.followedContent = isValidStoredFollow ? this.validateStoreFollow(JSON.parse(storedFollowString) || []) : []
      } catch (error) {
        this.$log.error(error)
        this.error = error.message
        return false
      }
    },
    async fetchContent () {
      if (this.userPreprCustomerId) {
        try {

          // Fetch Nested Articles
          if (this.followedContent && this.followedContent.length) {
            const responses = await Promise.allSettled(
              this.followedContent.map((content) => {
                if (content.type) {
                  switch(content.type) {
                    case 'program':
                      return this.$api.programs.getAllNested('articles', content.id, {
                        limit: 3,
                        offset: 0,
                      })
                    case 'person':
                      return this.$api.persons.getAllNested('articles', content.id, {
                        limit: 3,
                        offset: 0,
                        personType: 'author',
                      })
                  }
                }
              }),
            )

            responses.forEach((response, index) => {
              const articles = response.value?.data?.items || []
              this.$set(this.followedContent[index], 'articles', articles)
            })
          }
        } catch (error) {
          this.error = error.message
          this.isLoading = false
        }
      }
    },
    isValidJSON(jsonString) {
      try {
          return (JSON.parse(jsonString) && !!jsonString);
      } catch (error) {
        this.isInvalidJSON = true

        const referrer = process.client && document?.referrer
          const {
            message = 'Oeps! Er is iets mis gegaan met het ophalen van je instellingen / localstorage data.',
            path = referrer,
            severity,
            statusCode = 500,
          } = error

          this.$bugsnag.notify(new Error(`${statusCode}: ${message}`), (e) => {
            e.severity = severity || (statusCode === 404 ? 'info' : 'error')
            e.context = path
            e.addMetadata('Error info', {
              ...this.error,
              referrer,
            })
          })

          return false;
      }
    },
    validateStoreFollow(store) {
      return store.filter( item => {
        return item && item.id
      })
    },
  },
}

